import { useState } from "react";
import Label from "../../form/Label";
import Input from "../../form/input/InputField";
import Select from "../../form/Select";
import Button from "../../ui/button/Button";
import { Modal } from "../../ui/modal";

interface WebhookFilterModalProps {
  isOpen: boolean;
  onClose: () => void;
  onApply: (filters: { status: string; fromDate: string; toDate: string; type: string }) => void;
}

export const WebhookFilterModal: React.FC<WebhookFilterModalProps> = ({
  isOpen,
  onClose,
  onApply,
}) => {
  const [status, setStatus] = useState("all");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [type, setType] = useState("all");

  const handleApplyFilters = (e: React.FormEvent) => {
    e.preventDefault();
    onApply({ status, fromDate, toDate, type });
    onClose();
  };

  const statusOptions = [
    { value: "all", label: "All Statuses" },
    { value: "SUCCESSFUL", label: "Successful" },
    { value: "FAILED", label: "Failed" },
  ];

  const typeOptions = [
  { value: "all", label: "All Types" },
  { value: "payment_link", label: "Payment Link" },
  { value: "exchange", label: "Exchange" },
  { value: "wallet_creation", label: "Wallet Creation" },
  { value: "wallet_txn", label: "Wallet Transaction" },
  { value: "wallet_virtual_account", label: "Virtual Account" },
  { value: "stable_wallet_creation", label: "Stable Wallet Creation" },
  { value: "stable_wallet_txn", label: "Stable Wallet Transaction" },
];

  const resetFilters = () => {
    setStatus("all");
    setFromDate("");
    setToDate("");
    setType("all");
    onApply({ status: "all", fromDate: "", toDate: "", type: "all" });
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="max-w-md">
      <div className="p-6">
        <h3 className="text-xl font-semibold text-gray-800 dark:text-white/90 mb-6">
          Filter webhooks
        </h3>
        
        <form onSubmit={handleApplyFilters} className="space-y-6">
          <div>
            <Label className="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
              Type
            </Label>
            <Select
              value={type}
              options={typeOptions}
              onChange={(value) => setType(value)}
              className="w-full"
            />
          </div>

          <div>
            <Label className="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
              Status
            </Label>
            <Select
              value={status}
              options={statusOptions}
              onChange={(value) => setStatus(value)}
              className="w-full"
            />
          </div>

          <div>
            <Label className="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
              From Date
            </Label>
            <Input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              className="w-full"
            />
          </div>

          <div>
            <Label className="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
              To Date
            </Label>
            <Input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              className="w-full"
            />
          </div>

          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              className="flex-1"
              onClick={resetFilters}
            >
              Reset
            </Button>
            <Button type="submit" className="flex-1">
              Apply Filters
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};